import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import commonVi from '../languages/vi/translation.json';
import commonEn from '../languages/en/translation.json';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    defaultNS: 'translation',
    resources: {
      vi: {
        translation: commonVi,
      },
      en: {
        translation: commonEn,
      },
    },
    lng: localStorage.getItem('i18nextLng') ?? 'vi', // Ngôn ngữ mặc định
    fallbackLng: 'en', // Ngôn ngữ dự phòng
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
